import { __rest } from "tslib";
import * as React from 'react';
import CopyIcon from '@patternfly/react-icons/dist/js/icons/copy-icon';
import { Button } from '../Button';
import { Tooltip } from '../Tooltip';
export var ClipboardCopyButton = function ClipboardCopyButton(_a) {
  var onClick = _a.onClick,
      _a$exitDelay = _a.exitDelay,
      exitDelay = _a$exitDelay === void 0 ? 100 : _a$exitDelay,
      _a$entryDelay = _a.entryDelay,
      entryDelay = _a$entryDelay === void 0 ? 100 : _a$entryDelay,
      _a$maxWidth = _a.maxWidth,
      maxWidth = _a$maxWidth === void 0 ? '100px' : _a$maxWidth,
      _a$position = _a.position,
      position = _a$position === void 0 ? 'top' : _a$position,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? 'Copyable input' : _a$ariaLabel,
      id = _a.id,
      textId = _a.textId,
      children = _a.children,
      props = __rest(_a, ["onClick", "exitDelay", "entryDelay", "maxWidth", "position", 'aria-label', "id", "textId", "children"]);

  return React.createElement(Tooltip, {
    trigger: "mouseenter focus click",
    exitDelay: exitDelay,
    entryDelay: entryDelay,
    maxWidth: maxWidth,
    position: position,
    content: React.createElement("div", null, children)
  }, React.createElement(Button, Object.assign({
    type: "button",
    variant: "control",
    onClick: onClick,
    "aria-label": ariaLabel,
    id: id,
    "aria-labelledby": "".concat(id, " ").concat(textId)
  }, props), React.createElement(CopyIcon, null)));
};